(function($) {
	'use strict';

	/**
	 * Calculate overall maturity scores
	 * @param {Object} resultsObj - Results object containing categorized scores
	 * @param {boolean} isLegacyMode - Whether in legacy mode
	 * @returns {Object} - Overall maturity scores
	 */
	function calculateOverallMaturityScores(resultsObj, isLegacyMode = false) {
		// console.log('resultsObj inside calculateOverallMaturityScores', resultsObj);
		// console.log('isLegacyMode inside calculateOverallMaturityScores', isLegacyMode);
		
		// Extract the results from the object returned by calculateMaturityScoresByLevelPerCategory
		const results = resultsObj.results || resultsObj;

		// Use different level sets based on mode
		const levels = isLegacyMode ? 
			["P1", "P2", "P3", "P4", "P5"] : 
			["Foundational (Level 1)", "Hygiene (Level 2)", "Governed (Level 3)", "Controlled (Level 4)", "Monitored (Level 5)"];
		
		// Create level mapping that preserves the original key format
		const levelMapping = {};
		levels.forEach(level => {
			levelMapping[level] = level;
		});

		const levelScaledAverages = {};

		// Check if Overall scores are already calculated (from calculateMaturityScoresByLevelPerCategory)
		// These are more accurate as they use raw totals instead of averaging category scores
		if (results['Overall'] && typeof results['Overall'] === 'object') {
			// console.log('calculateOverallMaturityScores: Using pre-calculated Overall scores (more accurate)');
			levels.forEach(level => {
				const overallScore = results['Overall'][level];
				if (overallScore !== undefined && overallScore !== null && overallScore !== 'Not Applicable') {
					// Use the pre-calculated overall score (already scaled to 0-5)
					levelScaledAverages[levelMapping[level]] = overallScore;
					// console.log(`  ${level}: ${overallScore}`);
				} else {
					levelScaledAverages[levelMapping[level]] = 'Not Applicable';
				}
			});
		} else {
			// console.log('calculateOverallMaturityScores: Falling back to averaging category scores (less accurate)');
			// Fallback: Calculate by averaging category-level scores (less accurate due to rounding)
			levels.forEach(level => {
				let totalScaledScore = 0;
				let count = 0;

				Object.keys(results).forEach(category => {
					if (category !== 'Overall') {
						if (results[category][level] !== 'Not Applicable' && results[category][level] !== null) {
							const score = results[category][level];
							totalScaledScore += score;
							count++;
						}
					}
				});

				if (count > 0) {
					const averagedScore = totalScaledScore / count;
					levelScaledAverages[levelMapping[level]] = averagedScore;
					// console.log(`  ${level}: ${averagedScore} (averaged from ${count} categories)`);
				} else {
					levelScaledAverages[levelMapping[level]] = 'Not Applicable';
				}
			});
		}

		// console.log('calculateOverallMaturityScores: Final levelScaledAverages:', levelScaledAverages);
		return levelScaledAverages;
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { calculateOverallMaturityScores };
	} else if (typeof window !== 'undefined') {
		window.calculateOverallMaturityScores = calculateOverallMaturityScores;
	}

})(jQuery);
